var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPlusIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 15,
    viewBox: "0 0 14 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon/Plus"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Union",
    d: "M12.8333 6.17461C13.4777 6.17461 14 6.69696 14 7.34128C14 7.98562 13.4777 8.50794 12.8333 8.50794L8.18384 8.50796L8.18384 13.3333C8.18384 13.9777 7.6615 14.5 7.01717 14.5C6.37284 14.5 5.8505 13.9777 5.8505 13.3333V8.50796L1.16667 8.50794C0.522335 8.50794 0 7.98562 0 7.34128C0 6.69696 0.522333 6.17461 1.16667 6.17461H5.8505V1.66667C5.8505 1.02233 6.37284 0.5 7.01717 0.5C7.6615 0.5 8.18384 1.02233 8.18384 1.66667V6.17463L12.8333 6.17461Z",
    fill: "white"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlusIcon);
export default __webpack_public_path__ + "static/media/plusIcon.8a7c89b179d5b02550cfed83f36dc114.svg";
export { ForwardRef as ReactComponent };